import Polling from '../../Polling/Polling'
import { AuthConsumer } from '@eggplant/context'
import type { Error } from '@eggplant/types'
import type { PollingProps } from '../../types'

const TokenPolling = <ResponseInterface, >(props: PollingProps<ResponseInterface>) =>
  <AuthConsumer>
    {
      ({
        authToken,
        onAuthReject
      }) => {
        const handleError = (error: Error) => {
          const isAuthError =
            error.status &&
            error.status.toString().includes('401')

          if (isAuthError && authToken) onAuthReject()
        }

        const {
          extraHeaders: extraHeadersProp,
          ...allOtherProps
        } = props

        const extraHeaders = {
          Authorization: `Bearer ${authToken}`,
          ...extraHeadersProp
        }

        return (
          <Polling<ResponseInterface>
            extraHeaders={extraHeaders}
            onError={handleError}
            {...allOtherProps}
          />
        )
      }
    }
  </AuthConsumer>

export default TokenPolling
